'use strict';
const $ = (window.jQuery = window.$ = require('jquery'));

let Selector = {
    carousel: '.js-carousel'
};

let breakpoints = {
    xs: 0,
    sm: 544,
    md: 769,
    lg: 992,
    xl: 1440
};

let bindEvent = () => {
    $(Selector.carousel).each(function() {
        var $el = $(this);
        if ($el.hasClass('slick-initialized')) return;

        var childCount = $el.children().length;
        if (childCount <= 1) return;

        var resolution = $el.data('resolution');
        if (resolution && window.innerWidth >= breakpoints[resolution]) return;

        if ($el.data('noCarouselDesktop') && window.innerWidth >= breakpoints.lg) return;

        var config = {};
        var attrVal = $el.attr('data-slick');
        if (attrVal) {
            try { config = JSON.parse(attrVal); } catch (e) { /* noop */ }
        }

        if (config.slidesToShow && config.slidesToShow > childCount) {
            config.slidesToShow = childCount;
        }
        if (config.responsive) {
            var shouldUnslick = false;
            var sortedBps = config.responsive.slice().sort(function(a, b) { return a.breakpoint - b.breakpoint; });
            for (var i = 0; i < sortedBps.length; i++) {
                if (window.innerWidth < sortedBps[i].breakpoint) {
                    if (sortedBps[i].settings === 'unslick') shouldUnslick = true;
                    break;
                }
            }
            if (shouldUnslick) return;

            config.responsive.forEach(function(bp) {
                if (bp.settings && bp.settings !== 'unslick' && bp.settings.slidesToShow > childCount) {
                    bp.settings.slidesToShow = childCount;
                }
            });
        }

        $el.slick(config);
    });
};

module.exports = function() {
    if ($(Selector.carousel).length > 0) bindEvent();
};
